import React from 'react'
import PropTypes from 'prop-types'
import { map } from 'lodash'
import css from 'cape-style'
import LinkEl from 'cape-mixer/lib/Link/Link'
import { StickyContainer, Sticky } from 'react-sticky'

import HomeWrapper from '../Home/HomeWrapper'
import Search from '../Search/Search'
import FilterSelect from '../FilterSelect'
import Student from './Student'

import { GroupHeader, CustomSelect, SearchContainer, Wrapper, Box, Tag } from './styles'

function StudentListEl({ programOptions, students }) {
  const collectionId = 'Student'
  return (
    <HomeWrapper>
      <StickyContainer>
        <article id="studentList" className="text-left">
          <Wrapper width="full" z={2}>
            <Box shadow align="flex-end">
              <header>
                <Sticky>
                  {({ style, isSticky }) => (
                    <div style={{ display: 'flex', justifyContent: 'flex-end', ...style }}>
                      <SearchContainer isSticky={isSticky}>
                        <Search
                          collectionId={collectionId}
                          style={css('flexAuto')}
                          isSticky={isSticky}
                        />
                        {programOptions && (
                          <CustomSelect className="customSelect" style={css('flexAuto')}>
                            <FilterSelect
                              collectionId={collectionId}
                              fieldId="program"
                              options={programOptions}
                              firstOptionName="All Programs"
                            />
                          </CustomSelect>
                        )}
                      </SearchContainer>
                    </div>
                  )}
                </Sticky>
              </header>
            </Box>
          </Wrapper>

          <div style={{ minHeight: '2rem' }} />

          <Wrapper width="full">
            <Box shadow width="full">
              <Tag>
                Student List
                <LinkEl routeId="home">
                  <button>Exhibition Schedule</button>
                </LinkEl>
              </Tag>
              <StickyContainer>
                <ul className="student-list">
                  <Sticky>
                    {({ style }) => (
                      <li className="student header hidden-sm" style={style}>
                        <GroupHeader className="name">
                          <strong>Name</strong>
                        </GroupHeader>
                        <GroupHeader className="program">
                          <strong>Program</strong>
                        </GroupHeader>
                        <GroupHeader className="show">
                          <strong>Show</strong>
                        </GroupHeader>
                        <GroupHeader className="social" />
                      </li>
                    )}
                  </Sticky>

                  {map(students, item => (
                    <Student key={item.id} {...item} />
                  ))}
                </ul>
              </StickyContainer>
            </Box>
          </Wrapper>
        </article>
      </StickyContainer>
    </HomeWrapper>
  )
}

StudentListEl.propTypes = {
  students: PropTypes.oneOfType([
    PropTypes.objectOf(PropTypes.object),
    PropTypes.arrayOf(PropTypes.object),
  ]),
  programOptions: PropTypes.arrayOf(PropTypes.object),
}
StudentListEl.defaultProps = {
  students: null,
  programOptions: null,
}
export default StudentListEl
